import { render, staticRenderFns } from "./RefreshIcon.vue?vue&type=template&id=2774ff10&"
import script from "./RefreshIcon.vue?vue&type=script&lang=js&"
export * from "./RefreshIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports